import { Box, variables } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const DateFilterContainer = styled(Box)`
  &.MuiBox-root {
    display: flex;
    align-items: center;
    grid-gap: 1rem;
    flex-direction: row;

    .MuiFormControl-root {
      width: 200px;
      ${variables.mediaQuery.lessThan('desktop')`   
      width: 100%;
    `}
    }
    ${variables.mediaQuery.lessThan('desktop')`   
      width: 100%;
    `}
    ${variables.mediaQuery.lessThan('tablet')`   
      justify-content: center;
  `}
  }
`;

export const SearchContainer = styled(Box)`
  .MuiFormControl-root {
    width: 291px;
    ${variables.mediaQuery.lessThan('desktop')`   
      width: 100%;
  `}
  }
  ${variables.mediaQuery.lessThan('desktop')`   
      width: 100%;
  `}
`;
